import React, { useState, useEffect } from "react";
import "./Form1.scss";
import { FiArrowRight } from "react-icons/fi";
import { connect } from "react-redux";

import { signup } from "../../../store/auth/actions";

const Form1 = (props) => {
  const [state, setstate] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const disabledBtn = () => {
    if (!state.firstName || !state.lastName || !state.email || !state.password)
      return true;
    return false;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setstate({
      ...state,
      [name]: value,
    });
  };

  const handleSubmit = async() => {
    await props.signup({
      firstName: state.firstName,
      lastName: state.lastName,
      email: state.email,
      password: state.password,
    });
    props.clicking();
  };

  return (
    <div className="Form1 w-100">
      <div className="h1">My name is ...</div>
      <div className="input-wrapper">
        <input
          type="text"
          className="input form-control"
          placeholder="First Name"
          value={state.firstName}
          name="firstName"
          onChange={handleChange}
          required
        />
      </div>
      <div className="input-wrapper">
        <input
          type="text"
          className="input form-control"
          placeholder="Last Name"
          value={state.lastName}
          onChange={handleChange}
          name="lastName"
          required
        />
      </div>
      <div className="input-wrapper">
        <input
          type="text"
          className="input form-control"
          placeholder="Email Address"
          value={state.email}
          onChange={handleChange}
          name="email"
          required
        />
      </div>
      <div className="input-wrapper">
        <input
          type="password"
          className="input form-control"
          placeholder="Password"
          value={state.password}
          onChange={handleChange}
          name="password"
          required
        />
      </div>
      <div className="note text-muted text-left">
        Please enter your real name. You will have a chance to enter your
        professional or business name later.
      </div>
      <div className="my-5"></div>
      <div className="d-flex justify-content-end align-items-center ">
        <button
          className="btn btn-primary rounded-3 btn-lg mt-4"
          disabled={disabledBtn()}
          onClick={() => handleSubmit()}
        >
          Next
          <FiArrowRight className="ml-3" />
        </button>
      </div>
    </div>
  );
};

export default connect(null, {
  signup,
})(Form1);
